import React from 'react';
import { StickyNote } from 'lucide-react';
import type { ContextItem } from '@Types/knowledge';

interface KnowledgeMemoryPanelProps {
  item: ContextItem;
  onClick: () => void;
}

export const KnowledgeMemoryPanel = ({
  item,
  onClick,
}: KnowledgeMemoryPanelProps) => (
  <button
    type="button"
    onClick={onClick}
    className="group w-full flex items-start gap-3 rounded-lg border border-[#E4E9EC] border-l-[3px] border-l-[#007CA0] bg-white px-4 py-3.5 text-left shadow-[0_1px_2px_rgba(16,24,40,.03)] hover:border-[#B8D9E2] hover:shadow-[0_4px_12px_rgba(0,124,160,.08)] transition-all">
    <div className="h-9 w-9 rounded-lg bg-gradient-to-br from-[#E8F1F5] to-[#DCEEF5] text-[#007CA0] flex items-center justify-center flex-shrink-0 group-hover:scale-[1.02] transition-transform">
      <StickyNote className="h-4 w-4" />
    </div>
    <div className="flex-1 min-w-0">
      <div className="text-[13.5px] font-semibold text-[#252F33]">
        {item.name}
      </div>
      <div className="text-xs text-[#768D95] mt-1 line-clamp-2 leading-relaxed">
        {item.summary || item.description}
      </div>
    </div>
    <span className="text-[10px] font-bold uppercase tracking-wide text-[#007CA0] bg-[#E8F1F5] rounded-full px-2.5 py-1 flex-shrink-0 mt-0.5">
      Always on
    </span>
  </button>
);
